<template>
  <div class="card-option">
    <div class="card-option-content">
      <div class="card-option-content__image">
        <img :src="urlImg + 'img/' + image" />
      </div>
      <div class="card-option-content__info">
        <h4>
          {{ $t(title) }}
        </h4>
        <h5 class="text__secondary card-option-content__description">
          {{ $t(description) }}
        </h5>
      </div>
    </div>
  </div>
</template>

<script setup>
  await new Promise((res) => setTimeout(res, 700))

  defineProps({
    image: {
      type: String
    },
    title: {
      type: String,
      default: 'Default Title'
    },
    description: {
      type: String,
      default: 'Default Description'
    }
  })

  const urlImg = process.env.VUE_APP_SERVER_IMG
</script>

<style lang="scss" scoped>
  @import '@/scss/mixings';
  .card-option {
    @include d-flex(column, center, center);
    flex: 1;
    &-content {
      @include d-flex(column, center, flex-start, 16px);
      border-radius: 20px;
      background-color: var(--theme-color);
      &__image img {
        border-radius: 20px 20px 0 0;
        object-fit: cover;
        width: 85.08dvw;
        height: 20.873dvh;
      }
      &__info {
        @include d-flex(column, center, flex-start, 8px);
        padding: 0 16px 24px 16px;
      }
      &__description {
        font-weight: 400;
        line-height: 20px;
      }
    }
  }
</style>
